import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import translationEng from 'localization/en.json'
import createLocalBackend from 'localization/localBackend'

const localeLoaders = import.meta.glob([
  './localization/*.json',
  '!./localization/en.json',
  '!./localization/languages.json'
])
const localBackend = createLocalBackend(localeLoaders)

i18n
  .use(localBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false
    },
    ns: ['translation'],
    defaultNS: 'translation',
    resources: {
      en: {
        translation: translationEng
      }
    },
    partialBundledLanguages: true,
    load: 'languageOnly',
    react: {
      useSuspense: false
    }
  })

export default i18n
